import React from 'react';
function AlignStartVertical({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M17.4666 3.33334H4.1333M6.79997 6H8.1333C8.86968 6 9.46663 6.59696 9.46663 7.33334V15.3333C9.46663 16.0697 8.86968 16.6667 8.1333 16.6667H6.79997C6.06359 16.6667 5.46663 16.0697 5.46663 15.3333V7.33334C5.46663 6.59696 6.06359 6 6.79997 6ZM13.4666 6H14.8C15.5363 6 16.1333 6.59696 16.1333 7.33334V10.6667C16.1333 11.403 15.5363 12 14.8 12H13.4666C12.7303 12 12.1333 11.403 12.1333 10.6667V7.33334C12.1333 6.59696 12.7303 6 13.4666 6Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default AlignStartVertical;
